import { WorkPlanDto } from '@zopup/zop-types';

const daysFromNow = (days: number): Date => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
};

export const generateMockWorkPlans = (): WorkPlanDto[] => [
    {
        id: 'wp-gearbox-pm-001',
        code: 'WP-GEARBOX-PM',
        name: 'Gearbox Assembly - Preventive Maintenance',
        subjectType: 'Item',
        subjectId: 'item-gearbox-assy',
        workDefinitionId: 'bom-gear-01-r5',
        trigger: {
            type: 'Calendar',
            intervalValue: 30,
            intervalUnit: 'Days',
            recurrenceBasis: 'LastCompletion',
        },
        advanceNotice: { value: 3, unit: 'Days' },
        autoCreateWorkOrder: true,
        autoReleaseWorkOrder: false,
        active: true,
        scheduleState: {
            lastTriggeredAt: daysFromNow(-28),
            lastCompletedAt: daysFromNow(-25),
            nextDueAt: daysFromNow(5),
            lastGeneratedWorkOrderId: 'wo-gearbox-001',
        },
        version: 3,
    },
    {
        id: 'wp-ctrl-panel-cal-002',
        code: 'WP-CTRL-PANEL-CAL',
        name: 'Control Panel - Calibration Check',
        subjectType: 'Item',
        subjectId: 'item-ctrl-panel',
        workDefinitionId: 'bom-ctrl-panel-r2',
        trigger: {
            type: 'Calendar',
            intervalValue: 90,
            intervalUnit: 'Days',
            recurrenceBasis: 'FixedSchedule',
            anchorAt: daysFromNow(-60),
        },
        advanceNotice: { value: 7, unit: 'Days' },
        autoCreateWorkOrder: true,
        autoReleaseWorkOrder: true,
        active: true,
        scheduleState: {
            lastTriggeredAt: daysFromNow(-60),
            lastCompletedAt: daysFromNow(-58),
            nextDueAt: daysFromNow(30),
            lastGeneratedWorkOrderId: 'wo-ctrl-panel-002',
        },
        version: 2,
    },
    {
        id: 'wp-conveyor-meter-003',
        code: 'WP-CONVEYOR-METER',
        name: 'Conveyor Unit - Runtime Hours Service',
        subjectType: 'Asset',
        subjectId: 'asset-conveyor-line-1',
        workDefinitionId: 'bom-conveyor-belt-r1',
        trigger: {
            type: 'Meter',
            meterCode: 'RUNTIME_HOURS',
            intervalValue: 500,
            intervalUnit: 'Cycles',
            initialDueReading: 500,
            recurrenceBasis: 'LastTrigger',
        },
        autoCreateWorkOrder: true,
        autoReleaseWorkOrder: false,
        active: true,
        scheduleState: {
            lastTriggeredAt: daysFromNow(-40),
            lastTriggerReading: 4200,
            nextDueReading: 4700,
            lastGeneratedWorkOrderId: 'wo-conveyor-003',
        },
        version: 2,
    },
    {
        id: 'wp-hyd-cylinder-cond-004',
        code: 'WP-HYD-CYLINDER-COND',
        name: 'Hydraulic Cylinder - Seal Wear Condition Check',
        subjectType: 'Asset',
        subjectId: 'asset-press-01',
        workDefinitionId: 'bom-hyd-cylinder-r1',
        trigger: {
            type: 'Condition',
            conditionCode: 'SEAL_WEAR_THRESHOLD',
            recurrenceBasis: 'LastTrigger',
        },
        advanceNotice: { value: 1, unit: 'Days' },
        autoCreateWorkOrder: false,
        autoReleaseWorkOrder: false,
        active: true,
        scheduleState: {},
        version: 1,
    },
    {
        id: 'wp-steel-frame-manual-005',
        code: 'WP-STEEL-FRAME-MANUAL',
        name: 'Steel Frame Assembly - On-Demand Inspection',
        subjectType: 'Item',
        subjectId: 'item-steel-frame-assy',
        workDefinitionId: 'bom-steel-frame-r1',
        trigger: {
            type: 'Manual',
        },
        autoCreateWorkOrder: false,
        autoReleaseWorkOrder: false,
        active: true,
        scheduleState: {
            lastTriggeredAt: daysFromNow(-90),
            lastCompletedAt: daysFromNow(-89),
            lastGeneratedWorkOrderId: 'wo-steel-frame-005',
        },
        version: 1,
    },
    {
        id: 'wp-weld-fixture-cal-006',
        code: 'WP-WELD-FIXTURE-CAL',
        name: 'Weld Fixture - Quarterly Tooling Refresh',
        subjectType: 'Item',
        subjectId: 'item-weld-fixture',
        workDefinitionId: 'bom-weld-fixture-r1',
        trigger: {
            type: 'Calendar',
            intervalValue: 3,
            intervalUnit: 'Months',
            recurrenceBasis: 'LastCompletion',
        },
        advanceNotice: { value: 5, unit: 'Days' },
        autoCreateWorkOrder: true,
        autoReleaseWorkOrder: false,
        active: false,
        scheduleState: {
            lastTriggeredAt: daysFromNow(-95),
            lastCompletedAt: daysFromNow(-91),
            nextDueAt: daysFromNow(-1),
            lastGeneratedWorkOrderId: 'wo-weld-fixture-007',
        },
        version: 2,
    },
    {
        id: 'wp-packaging-meter-007',
        code: 'WP-PACKAGING-METER',
        name: 'Packaging Line - Cycle Count Service',
        subjectType: 'Instrument',
        subjectId: 'instrument-packaging-scale-1',
        trigger: {
            type: 'Meter',
            meterCode: 'CYCLE_COUNT',
            intervalValue: 10000,
            intervalUnit: 'Cycles',
            initialDueReading: 10000,
            recurrenceBasis: 'FixedSchedule',
        },
        autoCreateWorkOrder: false,
        autoReleaseWorkOrder: false,
        active: false,
        scheduleState: {
            lastTriggerReading: 8600,
            nextDueReading: 10000,
        },
        version: 1,
    },
    {
        id: 'wp-serial-batch-008',
        code: 'WP-SERIAL-BATCH-QA',
        name: 'Serial Batch QA - Random Sampling',
        subjectType: 'Serial',
        subjectId: 'serial-batch-2026-08',
        trigger: {
            type: 'Manual',
        },
        autoCreateWorkOrder: false,
        autoReleaseWorkOrder: false,
        active: true,
        scheduleState: {},
        version: 1,
    },
];
